import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import clinicService from '../../../../../services/clinic.service';
import userService from '../../../../../services/user.service';
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const ClinicUserAdd = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { clinicId } = useParams();
    const navigate = useNavigate();
    const [roles, setRoles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        getRoles()
    }, [])

    const getRoles = () => {
        userService.getRoles()
            .then(res => {
                setRoles(res.data)
            })
            .catch(err => {
                console.log(err)
                toast.error("Failed to load roles", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
    }

    const onSubmit = (data, e) => {
        setIsSubmitting(true);
        const newData = { ...data, secret: "ECXuserx1y1z1", clinicId: clinicId }

        userService.addUsers(clinicId, newData)
            .then(res => {
                e.target.reset();
                toast.success("Successfully added new user", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })

            })
            .catch(err => {
                console.log(err);
                toast.error(err.response?.data?.message || "Error while adding new user", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
            .finally(() => {
                setIsSubmitting(false);
            })
    }

    const handleBack = () =>    {
        navigate(-1);
    }

    return (
        <>
            <div className="card-padding shadow-none">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="card-title" style={{color: "#012970"}}>
                        {" "}
                        <i className="bi bi-people"></i> Doctors / Managers / Staff
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-8">
                    <div className="card card-padding shadow-none">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label htmlFor="firstName" className="form-label">
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                            {...register("firstName", { required: "First name is required" })}
                                            placeholder="Enter first name"
                                        />
                                        {errors.firstName && (
                                            <div className="invalid-feedback">
                                                {errors.firstName.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="lastName" className="form-label">
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                            {...register("lastName", { required: "Last name is required" })}
                                            placeholder="Enter last name"
                                        />
                                        {errors.lastName && (
                                            <div className="invalid-feedback">
                                                {errors.lastName.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="email" className="form-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            {...register("email", {
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Invalid email address"
                                                }
                                            })}
                                            placeholder="Enter email"
                                        />
                                        {errors.email && (
                                            <div className="invalid-feedback">
                                                {errors.email.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="role" className="form-label">
                                            Role <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="role"
                                            className={`form-select ${errors.role ? 'is-invalid' : ''}`}
                                            {...register("role", { required: "Role is required" })}
                                        >
                                            <option value="">Select a role</option>
                                            {roles.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.role && (
                                            <div className="invalid-feedback">
                                                {errors.role.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="isAuthenticated" className="form-label">
                                            Authentication Status <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="isAuthenticated"
                                            className={`form-select ${errors.isAuthenticated ? 'is-invalid' : ''}`}
                                            {...register("isAuthenticated", { required: "Authentication status is required" })}
                                        >
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </select>
                                        {errors.isAuthenticated && (
                                            <div className="invalid-feedback">
                                                {errors.isAuthenticated.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-12 mt-4">
                                        <div className="d-flex justify-content-end gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => reset()}
                                                disabled={isSubmitting}
                                            >
                                                <i className="bi bi-arrow-counterclockwise me-1"></i> Reset
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-sm"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Adding...
                                                    </>
                                                ) : (
                                                    <>
                                                    <i className="bi bi-floppy"></i> Save
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card border-primary shadow-none card-border">
                        <div className="card-header bg-primary text-white">
                            <h6 className="mb-0">
                                <i className="bi bi-info-circle me-2"></i>
                                Important Note
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="p-2"></div>
                            <div className="alert alert-info mb-0">
                                <p className="mb-0">
                                    <strong>Authentication Note:</strong> If you select "Yes" for authentication,
                                    the default password will be set to <code>ECXuserx1y1z1</code>.
                                </p>
                                <hr />
                                <p className="mb-0">
                                    For security, please use the "Reset Password" feature to send the user
                                    an email with password reset instructions to their registered email address.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ClinicUserAdd;